import React from 'react';
import { Switch } from 'antd';
import { FieldProps } from '.';

const BooleanField = ({ value, onChange, readonly }: FieldProps<boolean>) => {
  return <Switch disabled={readonly} checked={value} onChange={onChange} />;
};

export default BooleanField;
